import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  tr: {
    common: {
      settings: 'Ayarlar',
      profile: 'Profil Yönetimi',
      notifications: 'Bildirim Tercihleri',
      privacy: 'Gizlilik Ayarları',
      language: 'Dil Tercihi',
      save: 'Kaydet',
      cancel: 'Vazgeç',
    },
  },
  en: {
    common: {
      settings: 'Settings',
      profile: 'Profile Management',
      notifications: 'Notification Preferences',
      privacy: 'Privacy Settings',
      language: 'Language Preference',
      save: 'Save',
      cancel: 'Cancel',
    },
  },
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'tr',
    fallbackLng: 'tr',
    interpolation: { escapeValue: false },
  });

export default i18n;
